webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebaseApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyAExn1UpSdJanCXpmAyRPb8jWL5fgyHZKo',
  authDomain: 'controle-biodigestor.firebaseapp.com',
  databaseURL: 'https://controle-biodigestor.firebaseio.com',
  projectId: 'controle-biodigestor',
  storageBucket: 'controle-biodigestor.appspot.com',
  messagingSenderId: '200358044541'
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(410),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(434);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(430),
  /* scopeId */
  "data-v-cd1e8b56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


if (window.localStorage.getItem('token')) {
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
}

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = 'https://mpsolidtec.com.br/mpcontrolebio/public';
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

window.axios = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Graficos_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Graficos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_Graficos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue__);












var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: '/logout',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue___default.a
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default.a,
    name: 'Principal',
    meta: {
      namePtbr: 'Principal',
      nameDe: 'Main',
      nameEn: 'Home',
      nameEs: 'Principal',
      descriptionPtbr: 'Monitoramento do Biodigestor Granmolino',
      descriptionDe: 'Granmolino Biodigester Überwachung',
      descriptionEn: 'Granmolino Biodigester Monitoring',
      descriptionEs: 'Monitoreo de Biodigestores Granmolino',
      requiresAuth: true
    }
  }, {
    path: 'usuario',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue___default.a,
    name: 'Usuário',
    meta: {
      namePtbr: 'Usuário',
      nameDe: 'Benutzer',
      nameEn: 'User',
      nameEs: 'Usuario',
      descriptionPtbr: 'Edição dos dados de Usuário',
      descriptionDe: 'Benutzerdaten bearbeiten',
      descriptionEn: 'Editing User Data',
      descriptionEs: 'Edición de datos de usuario',
      requiresAuth: true
    }
  }, {
    path: 'manutencao',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue___default.a,
    name: 'Manutenção',
    meta: {
      namePtbr: 'Manutenção',
      nameDe: 'Wartung',
      nameEn: 'Maintenance',
      nameEs: 'Mantenimiento',
      descriptionPtbr: 'Monitoramento de todas variáveis do Biodigestor Granmolino',
      descriptionDe: 'Überwachung aller Variablen von Granmolino Biodigester',
      descriptionEn: 'Monitoring of all Granmolino Biodigester variables',
      descriptionEs: 'Monitoreo de todas las variables de Biodigestores Granmolino',
      requiresAuth: true
    }
  }, {
    path: 'graficos',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_Graficos_vue___default.a,
    name: 'Gráficos',
    meta: {
      namePtbr: 'Gráficos',
      nameDe: 'Diagramme',
      nameEn: 'Charts',
      nameEs: 'Gráficos',
      descriptionPtbr: 'Relatório das variáveis do Biodigestor Granmolino',
      descriptionDe: 'Grafik der Variablen des Biodigestor Granmolino',
      descriptionEn: 'Graph of the variables of the Biodigestor Granmolino',
      descriptionEs: 'Gráfico de las variables del Biodigestor Granmolino.',
      requiresAuth: true
    }
  }, {
    path: 'graficos-material',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue___default.a,
    name: 'Gráficos Material',
    meta: {
      namePtbr: 'Gráficos',
      nameDe: 'Diagramme',
      nameEn: 'Charts',
      nameEs: 'Gráficos',
      descriptionPtbr: 'Valores de análise do material do Biodigestor GranMolino',
      descriptionDe: 'Analysewerte des Materials des Biodigestor GranMolino',
      descriptionEn: 'Values ​​of analysis of the material of the Biodigestor GranMolino',
      descriptionEs: 'Valores de análisis del material del Biodigestor GranMolino.',
      requiresAuth: true
    }
  }, {
    path: 'graficos-acumulados',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue___default.a,
    name: 'Gráficos Acumulados',
    meta: {
      namePtbr: 'Gráficos',
      nameDe: 'Diagramme',
      nameEn: 'Charts',
      nameEs: 'Gráficos',
      descriptionPtbr: 'Crescimento diário dos valores acumulados.',
      descriptionDe: 'Tägliches Wachstum der akkumulierten Werte',
      descriptionEn: 'Daily growth of accumulated values',
      descriptionEs: 'Crecimiento diario de los valores acumulados.',
      requiresAuth: true
    }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules__ = __webpack_require__(69);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: __WEBPACK_IMPORTED_MODULE_5__modules__["default"]
}));

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(424),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_App_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_filters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_country_flag__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__axios__ = __webpack_require__(195);















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuefire___default.a);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue2_filters___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('country-flag', __WEBPACK_IMPORTED_MODULE_11_vue_country_flag__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('count', __WEBPACK_IMPORTED_MODULE_6__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('domain', __WEBPACK_IMPORTED_MODULE_6__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_6__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('pluralize', __WEBPACK_IMPORTED_MODULE_6__filters__["d" /* pluralize */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */],
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_analytics___default.a, {
  id: 'UA-156010815-1',
  router: router
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!router.app.$store.state.token || router.app.$store.state.token === 'null')) {
    window.console.log('Not authenticated');
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}



new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_7__components_App_vue___default.a);
  }
});

window.bugsnagClient = window.bugsnag('02fe1c2caaf5874c50b6ee19534f5932');
window.bugsnagClient.use(window.bugsnag__vue(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]));

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  dia: {},
  historico: {},
  acumulado: {},
  titulo: '',
  cnpj: ''
};

var mutations = {
  fillDataRelatorioDia: function fillDataRelatorioDia(state, res) {
    state.dia = res.data;
  },
  fillDataRelatorioHistorico: function fillDataRelatorioHistorico(state, res) {
    state.historico = res.data;
  },
  fillDataRelatorioAcumulado: function fillDataRelatorioAcumulado(state, res) {
    state.acumulado = res.data.grafico;
    state.titulo = res.data.titulo;
  },
  fillDataRelatorioHistoricoDias: function fillDataRelatorioHistoricoDias(state, res) {
    state.historico = res.data.grafico;
    state.titulo = res.data.titulo;
  }
};

var actions = {
  createRelatorioHistorico: function createRelatorioHistorico(context, data) {
    var qs = __webpack_require__(33);
    data = qs.stringify(data);
    return window.axios.post('/api/v1/sd032019/relatorios', data).then(function (res) {
      context.commit('fillDataRelatorioHistorico', res);
      return res;
    });
  },
  createRelatorioGeracaoSeteDias: function createRelatorioGeracaoSeteDias(context, data) {
    var qs = __webpack_require__(33);
    data = qs.stringify(data);
    return window.axios.post('/api/v1/sd032019/relatorios/setedias', data).then(function (res) {
      context.commit('fillDataRelatorioHistoricoDias', res);
      return res;
    });
  },
  createRelatorioAcumuladoDias: function createRelatorioAcumuladoDias(context, data) {
    var qs = __webpack_require__(33);
    console.log(data);
    data = qs.stringify(data);
    return window.axios.post('/api/v1/sd032019/relatorios/dias', data).then(function (res) {
      context.commit('fillDataRelatorioAcumulado', res);
      return res;
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  flag: 'uz',
  objeto: {
    name: 'Nome',
    email: 'Email'
  }
};

var mutations = {
  updateUserAtual: function updateUserAtual(state, res) {
    state.objeto = res.data;
  }
};

var actions = {
  updateUser: function updateUser(context, data) {
    var id = data.id;
    var qs = __webpack_require__(33);
    var dados = qs.stringify(data.turno);
    return window.axios.put('/api/v2/turnos/' + id, dados).then(function (res) {
      return res;
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_LANG: function SET_LANG(state, lang) {
    state.flag = lang;
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  flag: 'es'
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound',
  methods: {
    track: function track() {
      this.$ga.page('/404');
    }
  },
  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_DashHeader__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_DashHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_DashHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_DashFooter__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_DashFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__layout_DashFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hideseek__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hideseek__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    DashHeader: __WEBPACK_IMPORTED_MODULE_4__layout_DashHeader___default.a,
    DashFooter: __WEBPACK_IMPORTED_MODULE_5__layout_DashFooter___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].hideLogoOnMobile
      },
      error: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    flag: function flag() {
      return this.$store.state.flag;
    },
    user: function user() {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: '../static/img/users.png',
        roles: [this.$store.state.user.email]
      };
    },
    demo: function demo() {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: '../static/img/users.png',
        email: this.$store.state.user.email
      };
    }
  }),
  methods: {
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__ = __webpack_require__(6);




var db = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].database();
var usuario = {};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data(router) {
    return {
      section: 'Login',
      loading: '',
      email: '',
      password: '',
      response: ''
    };
  },

  methods: {
    switchLang: function switchLang(lang) {
      this.$store.commit('SET_LANG', lang);
    },

    signIn: function signIn() {
      var _this = this;

      this.toggleLoading();
      __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].auth().signInWithEmailAndPassword(this.email, this.password).then(function (resposta) {
        _this.toggleLoading();

        _this.$store.commit('SET_TOKEN', resposta.user.refreshToken);

        _this.$store.commit('SET_USER', __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser);
        var uid = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser.uid;
        var Users = db.ref('Users/' + uid);
        Users.on('value', function (snapshot) {
          usuario = snapshot.val();
          this.switchLang(usuario.flag);
        }, function (errorObject) {
          console.log('The read failed: ' + errorObject.code);
        });

        _this.$router.push('/');
      }, function (err) {
        _this.$store.commit('TOGGLE_LOADING');
        _this.toggleLoading();
        alert(err.message);
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logout',
  data: function data(router) {
    return {
      section: 'Logout',
      loading: '',
      password: '',
      response: '',
      email: ''
    };
  },
  mounted: function mounted() {
    this.signOut();
  },

  methods: {
    signOut: function signOut() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function (resposta) {
        _this.$store.commit('SET_TOKEN', null);
        _this.$store.commit('SET_USER', null);
        window.localStorage.setItem('token', null);
        window.localStorage.setItem('user', null);
        _this.$router.push('/login');
      });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chart',
  props: {
    'chart-config': {
      type: Object,
      validator: function validator(value) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value);
        if (!keys.includes('type')) {
          console.error('[Chart.js] Object must has type (key)');
          return false;
        }
        if (!keys.includes('data')) {
          console.error('[Chart.js] Object must has data (key)');
          return false;
        }
        return true;
      }
    }
  },
  mounted: function mounted() {
    var chartCanvas = this.$el.getContext('2d');
    var chartConfig = this.chartConfig;
    new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(chartCanvas, chartConfig);
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashFooter',
  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    }
  },
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessagesMenu__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessagesMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessagesMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationsMenu__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationsMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NotificationsMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguagesMenu__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguagesMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LanguagesMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TasksMenu__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TasksMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TasksMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserMenu__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserMenu__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashHeader',
  components: {
    MessagesMenu: __WEBPACK_IMPORTED_MODULE_2__MessagesMenu___default.a,
    LanguagesMenu: __WEBPACK_IMPORTED_MODULE_4__LanguagesMenu___default.a,
    NotificationsMenu: __WEBPACK_IMPORTED_MODULE_3__NotificationsMenu___default.a,
    TasksMenu: __WEBPACK_IMPORTED_MODULE_5__TasksMenu___default.a,
    UserMenu: __WEBPACK_IMPORTED_MODULE_6__UserMenu___default.a
  },
  props: ['user'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    demo: function demo() {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: '../static/img/users.png',
        email: this.$store.state.user.email
      };
    }
  })
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_country_flag__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationItem__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NotificationItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_filters__);









var db = __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd032019Ref = db.ref('sd032019');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LanguagensMenu',
  components: {
    NotificationItem: __WEBPACK_IMPORTED_MODULE_3__NotificationItem___default.a,
    CountryFlag: __WEBPACK_IMPORTED_MODULE_1_vue_country_flag__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vue2_filters___default.a.mixin],
  data: function data() {
    return {
      tab: 'new'
    };
  },

  firebase: {
    registros: {
      source: sd032019Ref,
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userInfo']), {
    flag: function flag() {
      return this.$store.state.flag;
    },
    newNotifications: function newNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      });
    },
    oldNotifications: function oldNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return n.readAt;
      });
    }
  }),
  methods: {
    markAllAsRead: function markAllAsRead() {
      event.stopPropagation();

      this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      }).forEach(function (notification) {
        notification.readAt = new Date().toUTCString;
      });
    },
    switchLang: function switchLang(lang) {
      this.$store.commit('SET_LANG', lang);
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessageItem',
  props: ['message']
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageItem__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessageItem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessagesMenu',
  components: {
    MessageItem: __WEBPACK_IMPORTED_MODULE_2__MessageItem___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['notification']
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationItem__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NotificationItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);








var db = __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd032019Ref = db.ref('sd032019');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotificationsMenu',
  components: {
    NotificationItem: __WEBPACK_IMPORTED_MODULE_2__NotificationItem___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a.mixin],
  data: function data() {
    return {
      tab: 'new'
    };
  },

  firebase: {
    registros: {
      source: sd032019Ref,
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    flag: function flag() {
      return this.$store.state.flag;
    },
    newNotifications: function newNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      });
    },
    oldNotifications: function oldNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return n.readAt;
      });
    }
  }),
  methods: {
    markAllAsRead: function markAllAsRead() {
      event.stopPropagation();
      this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      }).forEach(function (notification) {
        notification.readAt = new Date().toUTCString;
      });
    },
    switchTab: function switchTab(event, tab) {
      event.stopPropagation();
      this.tab = tab;
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarMenu',
  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TasksMenu',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserMenu',
  props: ['user']
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VAChart__);






var db = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd032019Ref = db.ref('sd032019');

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue2_filters___default.a.mixin],
  data: function data() {
    return {
      carregar: false,
      pesquisa: {
        titulo: 'titulo',
        parametro: 'DsPotenciaAcumuladaGerador',
        label: 'label'
      }
    };
  },

  components: {
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__VAChart___default.a
  },
  firebase: {
    registros: {
      source: sd032019Ref,
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  methods: {
    track: function track() {
      this.$ga.page('/');
    },
    createRelatorioGeracaoSeteDias: function createRelatorioGeracaoSeteDias(pesquisa) {
      var _this = this;

      this.$store.dispatch('createRelatorioGeracaoSeteDias', pesquisa).then(function (response) {
        _this.carregar = true;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var bandeira = this.$store.state.flag;
    switch (bandeira) {
      case 'br':
        this.pesquisa.titulo = 'KW/h produzidos a partir do dia';
        this.pesquisa.label = 'Potência Acumulada do Gerador';
        break;
      case 'de':
        this.pesquisa.titulo = 'KW/h produziert ab Tag';
        this.pesquisa.label = 'Akkumulierte Generatorleistung';
        break;
      case 'us':
        this.pesquisa.titulo = 'KW/h produced from day';
        this.pesquisa.label = 'Accumulated Generator Power';
        break;
      default:
        this.pesquisa.titulo = 'KW/h producidos a partir del día';
        this.pesquisa.label = 'Potencia acumulada del generador';
        break;
    }
    this.createRelatorioGeracaoSeteDias(this.pesquisa);
  },

  computed: {
    producaoGrafico: function producaoGrafico() {
      return this.$store.state.Relatorios.historico;
    },
    flag: function flag() {
      return this.$store.state.flag;
    },
    producaoGraficoTitulo: function producaoGraficoTitulo() {
      return this.$store.state.Relatorios.titulo;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);







var db = __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd032019Ref = db.ref('sd032019');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Relatorios',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a.mixin],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__VAChart___default.a
  },
  firebase: {
    registros: {
      source: sd032019Ref,
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  mounted: function mounted() {},

  computed: {
    producaoGrafico: function producaoGrafico() {
      return this.$store.state.Relatorios.historico;
    },
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["a" /* ptBR */],
      en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["b" /* en */],
      es: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["c" /* es */],
      de: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["d" /* de */],
      registros: {},
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: ''
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    track: function track() {
      this.$ga.page('/graficos');
    },
    debug: function debug(parametro, label) {
      console.log('Debug parametro: ' + parametro);
      console.log('Debug label: ' + label);
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    efetuarPesquisa: function efetuarPesquisa(bandeira) {
      var _this = this;

      var DadosInvalidos = 'DadosInvalidos';
      var DataVazia = 'DataVazia';
      var DataFinalAnterior = 'DataFinalAnterior';
      var SelecionarParametro = 'SelecionarParametro';
      var EnviandoDados = 'EnviandoDados';
      var AguardeGerar = 'AguardeGerar';
      switch (bandeira) {
        case 'br':
          DadosInvalidos = 'Dados inválidos!';
          DataVazia = 'Não pode ter data vazia!';
          DataFinalAnterior = 'Data final não pode ser anterior à data inicial!';
          SelecionarParametro = 'Favor selecionar um parâmetro de pesquisa!';
          EnviandoDados = 'Enviando dados!';
          AguardeGerar = 'Aguarde enquanto o gráfico está sendo gerado!';
          break;
        case 'de':
          DadosInvalidos = 'Ungültige Daten!';
          DataVazia = 'Kann kein leeres Datum haben!';
          DataFinalAnterior = 'Das Enddatum darf nicht vor dem Startdatum liegen!';
          SelecionarParametro = 'Bitte wählen Sie einen Suchparameter!';
          EnviandoDados = 'Daten senden!';
          AguardeGerar = 'Warten Sie, während das Diagramm generiert wird!';
          break;
        case 'us':
          DadosInvalidos = 'Invalid data!';
          DataVazia = 'Cannot have empty date!';
          DataFinalAnterior = 'End date cannot be earlier than start date!';
          SelecionarParametro = 'Please select a search parameter!';
          EnviandoDados = 'Sending data!';
          AguardeGerar = 'Wait while the chart is being generated!';
          break;
        default:
          DadosInvalidos = 'Datos inválidos!';
          DataVazia = '¡No se puede tener una fecha vacía!';
          DataFinalAnterior = '¡La fecha de finalización no puede ser anterior a la fecha de inicio!';
          SelecionarParametro = 'Por favor, seleccione un parámetro de búsqueda!';
          EnviandoDados = 'Enviando datos!';
          AguardeGerar = '¡Espere mientras se genera el gráfico!';
          break;
      }
      this.exibirGrafico = false;
      if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showAlert(DadosInvalidos, DataVazia, 'warning', true, 'Ok');
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showAlert(DadosInvalidos, DataFinalAnterior, 'warning', true, 'Ok');
      } else if (this.parametro[0] === '') {
        this.showAlert(DadosInvalidos, SelecionarParametro, 'warning', true, 'Ok');
      } else {
        this.showAlert(EnviandoDados, AguardeGerar, 'info', false, 'Ok');
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.pesquisa.parametro = this.parametro[0];
        this.pesquisa.label = this.parametro[1] + ' ' + this.parametro[2];
        this.$store.dispatch('createRelatorioHistorico', this.pesquisa).then(function (response) {
          _this.$swal.close();
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);







var db = __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd032019Ref = db.ref('sd032019');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelatoriosAcumulados',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a.mixin],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__VAChart___default.a
  },
  firebase: {
    registros: {
      source: sd032019Ref,
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  mounted: function mounted() {},

  computed: {
    producaoGrafico: function producaoGrafico() {
      return this.$store.state.Relatorios.acumulado;
    },
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["a" /* ptBR */],
      en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["b" /* en */],
      es: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["c" /* es */],
      de: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["d" /* de */],
      registros: {},
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: ''
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    track: function track() {
      this.$ga.page('/graficos-acumulados');
    },
    debug: function debug(parametro, label) {
      console.log('Debug parametro: ' + parametro);
      console.log('Debug label: ' + label);
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    efetuarPesquisa: function efetuarPesquisa(bandeira) {
      var _this = this;

      var DadosInvalidos = 'DadosInvalidos';
      var DataVazia = 'DataVazia';
      var DataFinalAnterior = 'DataFinalAnterior';
      var SelecionarParametro = 'SelecionarParametro';
      var EnviandoDados = 'EnviandoDados';
      var AguardeGerar = 'AguardeGerar';
      switch (bandeira) {
        case 'br':
          DadosInvalidos = 'Dados inválidos!';
          DataVazia = 'Não pode ter data vazia!';
          DataFinalAnterior = 'Data final não pode ser anterior à data inicial!';
          SelecionarParametro = 'Favor selecionar um parâmetro de pesquisa!';
          EnviandoDados = 'Enviando dados!';
          AguardeGerar = 'Aguarde enquanto o gráfico está sendo gerado!';
          break;
        case 'de':
          DadosInvalidos = 'Ungültige Daten!';
          DataVazia = 'Kann kein leeres Datum haben!';
          DataFinalAnterior = 'Das Enddatum darf nicht vor dem Startdatum liegen!';
          SelecionarParametro = 'Bitte wählen Sie einen Suchparameter!';
          EnviandoDados = 'Daten senden!';
          AguardeGerar = 'Warten Sie, während das Diagramm generiert wird!';
          break;
        case 'us':
          DadosInvalidos = 'Invalid data!';
          DataVazia = 'Cannot have empty date!';
          DataFinalAnterior = 'End date cannot be earlier than start date!';
          SelecionarParametro = 'Please select a search parameter!';
          EnviandoDados = 'Sending data!';
          AguardeGerar = 'Wait while the chart is being generated!';
          break;
        default:
          DadosInvalidos = 'Datos inválidos!';
          DataVazia = '¡No se puede tener una fecha vacía!';
          DataFinalAnterior = '¡La fecha de finalización no puede ser anterior a la fecha de inicio!';
          SelecionarParametro = 'Por favor, seleccione un parámetro de búsqueda!';
          EnviandoDados = 'Enviando datos!';
          AguardeGerar = '¡Espere mientras se genera el gráfico!';
          break;
      }
      this.exibirGrafico = false;
      if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showAlert(DadosInvalidos, DataVazia, 'warning', true, 'Ok');
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showAlert(DadosInvalidos, DataFinalAnterior, 'warning', true, 'Ok');
      } else if (this.parametro[0] === '') {
        this.showAlert(DadosInvalidos, SelecionarParametro, 'warning', true, 'Ok');
      } else {
        this.showAlert(EnviandoDados, AguardeGerar, 'info', false, 'Ok');
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.pesquisa.parametro = this.parametro[0];
        this.pesquisa.label = this.parametro[1] + ' ' + this.parametro[2];
        this.$store.dispatch('createRelatorioAcumuladoDias', this.pesquisa).then(function (response) {
          _this.$swal.close();
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);







var db = __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd032019Ref = db.ref('sd032019');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelatoriosMaterial',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a.mixin],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__VAChart___default.a
  },
  firebase: {
    registros: {
      source: sd032019Ref,
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  mounted: function mounted() {},

  computed: {
    producaoGrafico: function producaoGrafico() {
      return this.$store.state.Relatorios.historico;
    },
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["a" /* ptBR */],
      en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["b" /* en */],
      es: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["c" /* es */],
      de: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["d" /* de */],
      registros: {},
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: ''
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    track: function track() {
      this.$ga.page('/graficos-material');
    },
    debug: function debug(parametro, label) {
      console.log('Debug parametro: ' + parametro);
      console.log('Debug label: ' + label);
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    efetuarPesquisa: function efetuarPesquisa(bandeira) {
      var _this = this;

      var DadosInvalidos = 'DadosInvalidos';
      var DataVazia = 'DataVazia';
      var DataFinalAnterior = 'DataFinalAnterior';
      var SelecionarParametro = 'SelecionarParametro';
      var EnviandoDados = 'EnviandoDados';
      var AguardeGerar = 'AguardeGerar';
      switch (bandeira) {
        case 'br':
          DadosInvalidos = 'Dados inválidos!';
          DataVazia = 'Não pode ter data vazia!';
          DataFinalAnterior = 'Data final não pode ser anterior à data inicial!';
          SelecionarParametro = 'Favor selecionar um parâmetro de pesquisa!';
          EnviandoDados = 'Enviando dados!';
          AguardeGerar = 'Aguarde enquanto o gráfico está sendo gerado!';
          break;
        case 'de':
          DadosInvalidos = 'Ungültige Daten!';
          DataVazia = 'Kann kein leeres Datum haben!';
          DataFinalAnterior = 'Das Enddatum darf nicht vor dem Startdatum liegen!';
          SelecionarParametro = 'Bitte wählen Sie einen Suchparameter!';
          EnviandoDados = 'Daten senden!';
          AguardeGerar = 'Warten Sie, während das Diagramm generiert wird!';
          break;
        case 'us':
          DadosInvalidos = 'Invalid data!';
          DataVazia = 'Cannot have empty date!';
          DataFinalAnterior = 'End date cannot be earlier than start date!';
          SelecionarParametro = 'Please select a search parameter!';
          EnviandoDados = 'Sending data!';
          AguardeGerar = 'Wait while the chart is being generated!';
          break;
        default:
          DadosInvalidos = 'Datos inválidos!';
          DataVazia = '¡No se puede tener una fecha vacía!';
          DataFinalAnterior = '¡La fecha de finalización no puede ser anterior a la fecha de inicio!';
          SelecionarParametro = 'Por favor, seleccione un parámetro de búsqueda!';
          EnviandoDados = 'Enviando datos!';
          AguardeGerar = '¡Espere mientras se genera el gráfico!';
          break;
      }
      this.exibirGrafico = false;
      if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showAlert(DadosInvalidos, DataVazia, 'warning', true, 'Ok');
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showAlert(DadosInvalidos, DataFinalAnterior, 'warning', true, 'Ok');
      } else if (this.parametro[0] === '') {
        this.showAlert(DadosInvalidos, SelecionarParametro, 'warning', true, 'Ok');
      } else {
        this.showAlert(EnviandoDados, AguardeGerar, 'info', false, 'Ok');
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.pesquisa.parametro = this.parametro[0];
        this.pesquisa.label = this.parametro[1] + ' ' + this.parametro[2];
        this.$store.dispatch('createRelatorioHistorico', this.pesquisa).then(function (response) {
          _this.$swal.close();
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_filters__);





var db = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd032019Ref = db.ref('sd032019');

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue2_filters___default.a.mixin],
  data: function data() {
    return {
      generateRandomNumbers: function generateRandomNumbers(numbers, max, min) {
        var a = [];
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max);
        }
        return a;
      }
    };
  },

  firebase: {
    registros: {
      source: sd032019Ref,
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  methods: {
    track: function track() {
      this.$ga.page('/manutencao');
    }
  },
  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'usuario',
  mounted: function mounted() {
    this.buscarUsuario();
  },

  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      displayNameNew: ''
    };
  },

  methods: {
    track: function track() {
      this.$ga.page('/usuario');
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    buscarUsuario: function buscarUsuario() {
      this.displayNameNew = this.$store.state.user.displayName;
    },
    alterarNomeUsuario: function alterarNomeUsuario() {
      var NomeAlterado = 'NomeAlterado';
      var FavorLogar = 'FavorLogar';
      var NaoAtendida = 'NaoAtendida';
      var FalhaNome = 'FalhaNome';
      var bandeira = this.$store.state.flag;
      switch (bandeira) {
        case 'br':
          NomeAlterado = 'Nome alterado com sucesso!';
          FavorLogar = 'Favor logar novamente para as alterações serem exibidas!';
          NaoAtendida = 'Solicitação não atendida!';
          FalhaNome = 'Falha ao alterar o nome!';
          break;
        case 'de':
          NomeAlterado = 'Name erfolgreich geändert!';
          FavorLogar = 'Bitte melden Sie sich erneut an, damit die Änderungen angezeigt werden!';
          NaoAtendida = 'Anfrage verpasst!';
          FalhaNome = 'Änderung des Namens fehlgeschlagen!';
          break;
        case 'us':
          NomeAlterado = 'Name changed successfully!';
          FavorLogar = 'Please log in again for changes to be displayed!';
          NaoAtendida = 'Request missed!';
          FalhaNome = 'Failed to change name!';
          break;
        default:
          NomeAlterado = 'Nombre cambiado con éxito!';
          FavorLogar = '¡Vuelva a iniciar sesión para que se muestren los cambios!';
          NaoAtendida = 'Solicitud perdida!';
          FalhaNome = '¡No se pudo cambiar el nombre!';
          break;
      }
      var user = __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser;
      var confirmar = user.updateProfile({
        displayName: this.displayNameNew
      }).then(function () {
        this.$store.commit('SET_USER', __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser);
        window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser));
        return true;
      }).catch(function (error) {
        console.log(error);
        return false;
      });
      if (confirmar) {
        this.showAlert(NomeAlterado, FavorLogar, 'info', true, 'Ok');
      } else {
        this.showAlert(NaoAtendida, FalhaNome, 'warning', true, 'Ok');
      }
    },
    alterarSenhaUsuario: function alterarSenhaUsuario() {
      var NaoAtendida = 'NaoAtendida';
      var Atendida = 'Atendida';
      var EmailEnviado = 'EmailEnviado';
      var EmailFalha = 'EmailFalha';
      var bandeira = this.$store.state.flag;
      switch (bandeira) {
        case 'br':
          NaoAtendida = 'Solicitação não atendida!';
          Atendida = 'Solicitação efetuada com Sucesso!';
          EmailEnviado = 'Email de redefinição de senha enviado para ';
          EmailFalha = 'Falha ao enviar email de redefinição de senha para ';
          break;
        case 'de':
          NaoAtendida = 'Anfrage verpasst!';
          Atendida = 'Anfrage erfolgreich gestellt!';
          EmailEnviado = 'E-Mail zum Zurücksetzen des Passworts gesendet an ';
          EmailFalha = 'Fehler beim Senden der E-Mail zum Zurücksetzen des Kennworts an ';
          break;
        case 'us':
          NaoAtendida = 'Request missed!';
          Atendida = 'Request made successfully!';
          EmailEnviado = 'Password reset email sent to ';
          EmailFalha = 'Failed to send password reset email to ';
          break;
        default:
          NaoAtendida = 'Solicitud perdida!';
          Atendida = 'Solicitud realizada con éxito!';
          EmailEnviado = 'Correo electrónico de restablecimiento de contraseña enviado a ';
          EmailFalha = 'Error al enviar el correo electrónico de restablecimiento de contraseña a ';
          break;
      }
      var auth = __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth();
      var emailAddress = this.$store.state.user.email;
      var confirmar = auth.sendPasswordResetEmail(emailAddress).then(function () {
        return true;
      }).catch(function (error) {
        console.log(error);
        return false;
      });
      if (confirmar) {
        this.showAlert(Atendida, EmailEnviado + emailAddress, 'info', true, 'Ok');
      } else {
        this.showAlert(NaoAtendida, EmailFalha + emailAddress, 'warning', true, 'Ok');
      }
    }
  }
});

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */,
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 74,
	"./af.js": 74,
	"./ar": 81,
	"./ar-dz": 75,
	"./ar-dz.js": 75,
	"./ar-kw": 76,
	"./ar-kw.js": 76,
	"./ar-ly": 77,
	"./ar-ly.js": 77,
	"./ar-ma": 78,
	"./ar-ma.js": 78,
	"./ar-sa": 79,
	"./ar-sa.js": 79,
	"./ar-tn": 80,
	"./ar-tn.js": 80,
	"./ar.js": 81,
	"./az": 82,
	"./az.js": 82,
	"./be": 83,
	"./be.js": 83,
	"./bg": 84,
	"./bg.js": 84,
	"./bm": 85,
	"./bm.js": 85,
	"./bn": 86,
	"./bn.js": 86,
	"./bo": 87,
	"./bo.js": 87,
	"./br": 88,
	"./br.js": 88,
	"./bs": 89,
	"./bs.js": 89,
	"./ca": 90,
	"./ca.js": 90,
	"./cs": 91,
	"./cs.js": 91,
	"./cv": 92,
	"./cv.js": 92,
	"./cy": 93,
	"./cy.js": 93,
	"./da": 94,
	"./da.js": 94,
	"./de": 97,
	"./de-at": 95,
	"./de-at.js": 95,
	"./de-ch": 96,
	"./de-ch.js": 96,
	"./de.js": 97,
	"./dv": 98,
	"./dv.js": 98,
	"./el": 99,
	"./el.js": 99,
	"./en-au": 100,
	"./en-au.js": 100,
	"./en-ca": 101,
	"./en-ca.js": 101,
	"./en-gb": 102,
	"./en-gb.js": 102,
	"./en-ie": 103,
	"./en-ie.js": 103,
	"./en-nz": 104,
	"./en-nz.js": 104,
	"./eo": 105,
	"./eo.js": 105,
	"./es": 108,
	"./es-do": 106,
	"./es-do.js": 106,
	"./es-us": 107,
	"./es-us.js": 107,
	"./es.js": 108,
	"./et": 109,
	"./et.js": 109,
	"./eu": 110,
	"./eu.js": 110,
	"./fa": 111,
	"./fa.js": 111,
	"./fi": 112,
	"./fi.js": 112,
	"./fo": 113,
	"./fo.js": 113,
	"./fr": 116,
	"./fr-ca": 114,
	"./fr-ca.js": 114,
	"./fr-ch": 115,
	"./fr-ch.js": 115,
	"./fr.js": 116,
	"./fy": 117,
	"./fy.js": 117,
	"./gd": 118,
	"./gd.js": 118,
	"./gl": 119,
	"./gl.js": 119,
	"./gom-latn": 120,
	"./gom-latn.js": 120,
	"./gu": 121,
	"./gu.js": 121,
	"./he": 122,
	"./he.js": 122,
	"./hi": 123,
	"./hi.js": 123,
	"./hr": 124,
	"./hr.js": 124,
	"./hu": 125,
	"./hu.js": 125,
	"./hy-am": 126,
	"./hy-am.js": 126,
	"./id": 127,
	"./id.js": 127,
	"./is": 128,
	"./is.js": 128,
	"./it": 129,
	"./it.js": 129,
	"./ja": 130,
	"./ja.js": 130,
	"./jv": 131,
	"./jv.js": 131,
	"./ka": 132,
	"./ka.js": 132,
	"./kk": 133,
	"./kk.js": 133,
	"./km": 134,
	"./km.js": 134,
	"./kn": 135,
	"./kn.js": 135,
	"./ko": 136,
	"./ko.js": 136,
	"./ky": 137,
	"./ky.js": 137,
	"./lb": 138,
	"./lb.js": 138,
	"./lo": 139,
	"./lo.js": 139,
	"./lt": 140,
	"./lt.js": 140,
	"./lv": 141,
	"./lv.js": 141,
	"./me": 142,
	"./me.js": 142,
	"./mi": 143,
	"./mi.js": 143,
	"./mk": 144,
	"./mk.js": 144,
	"./ml": 145,
	"./ml.js": 145,
	"./mr": 146,
	"./mr.js": 146,
	"./ms": 148,
	"./ms-my": 147,
	"./ms-my.js": 147,
	"./ms.js": 148,
	"./mt": 149,
	"./mt.js": 149,
	"./my": 150,
	"./my.js": 150,
	"./nb": 151,
	"./nb.js": 151,
	"./ne": 152,
	"./ne.js": 152,
	"./nl": 154,
	"./nl-be": 153,
	"./nl-be.js": 153,
	"./nl.js": 154,
	"./nn": 155,
	"./nn.js": 155,
	"./pa-in": 156,
	"./pa-in.js": 156,
	"./pl": 157,
	"./pl.js": 157,
	"./pt": 159,
	"./pt-br": 158,
	"./pt-br.js": 158,
	"./pt.js": 159,
	"./ro": 160,
	"./ro.js": 160,
	"./ru": 161,
	"./ru.js": 161,
	"./sd": 162,
	"./sd.js": 162,
	"./se": 163,
	"./se.js": 163,
	"./si": 164,
	"./si.js": 164,
	"./sk": 165,
	"./sk.js": 165,
	"./sl": 166,
	"./sl.js": 166,
	"./sq": 167,
	"./sq.js": 167,
	"./sr": 169,
	"./sr-cyrl": 168,
	"./sr-cyrl.js": 168,
	"./sr.js": 169,
	"./ss": 170,
	"./ss.js": 170,
	"./sv": 171,
	"./sv.js": 171,
	"./sw": 172,
	"./sw.js": 172,
	"./ta": 173,
	"./ta.js": 173,
	"./te": 174,
	"./te.js": 174,
	"./tet": 175,
	"./tet.js": 175,
	"./th": 176,
	"./th.js": 176,
	"./tl-ph": 177,
	"./tl-ph.js": 177,
	"./tlh": 178,
	"./tlh.js": 178,
	"./tr": 179,
	"./tr.js": 179,
	"./tzl": 180,
	"./tzl.js": 180,
	"./tzm": 182,
	"./tzm-latn": 181,
	"./tzm-latn.js": 181,
	"./tzm.js": 182,
	"./uk": 183,
	"./uk.js": 183,
	"./ur": 184,
	"./ur.js": 184,
	"./uz": 186,
	"./uz-latn": 185,
	"./uz-latn.js": 185,
	"./uz.js": 186,
	"./vi": 187,
	"./vi.js": 187,
	"./x-pseudo": 188,
	"./x-pseudo.js": 188,
	"./yo": 189,
	"./yo.js": 189,
	"./zh-cn": 190,
	"./zh-cn.js": 190,
	"./zh-hk": 191,
	"./zh-hk.js": 191,
	"./zh-tw": 192,
	"./zh-tw.js": 192
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 383;

/***/ }),
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(414),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(426),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(412),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(415),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(367)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(411),
  /* scopeId */
  "data-v-155c01f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  "data-v-6c8c05d3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(413),
  /* scopeId */
  "data-v-1a0f9940",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(416),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(429),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(431),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(418),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(423),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(417),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(420),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(421),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(409),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "row center-block"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Nome do Usuário")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Benutzername")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Username")]) : _c('span', [_vm._v("Nombre de usuario")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        _vm.alterarNomeUsuario()
      }
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Gravar")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Aufnehmen")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Save")]) : _c('span', [_vm._v("Registro")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        _vm.alterarSenhaUsuario()
      }
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Redefinir Senha")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Passwort zurücksetzen")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Redefine password")]) : _c('span', [_vm._v("Restablecer contraseña")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas')
},staticRenderFns: []}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('country-flag', {
    attrs: {
      "country": _vm.flag,
      "size": "small"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, [_c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('es')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "es",
      "size": "small"
    }
  }), _vm._v(" Español\n        ")], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('us')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "us",
      "size": "small"
    }
  }), _vm._v(" English\n        ")], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('de')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "de",
      "size": "small"
    }
  }), _vm._v(" Deutsche\n        ")], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('br')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "br",
      "size": "small"
    }
  }), _vm._v(" Português\n        ")], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_alarme'), 1, 'valor'))))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, _vm._l((_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_alarme'), 1, 'valor')), function(registro) {
    return _c('span', {
      staticClass: "col-xs-12 col-md-6 tab-link"
    }, [(_vm.flag === 'br') ? _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelPtBr))]) : (_vm.flag === 'de') ? _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelDe))]) : (_vm.flag === 'us') ? _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelEn))]) : _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelEs))])])
  }))]), _vm._v(" "), _c('li', [(_vm.tab === 'old') ? _c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_alarme'), 1, 'valor')), function(notification) {
    return _c('notification-item', {
      key: notification.id,
      attrs: {
        "notification": notification
      }
    })
  }), _vm._v(" "), (!_vm.oldNotifications.length) ? _c('li', [_c('span', {
    staticClass: "center-block text-center"
  }, [_vm._v("Não existe nenhum alerta/alarme")])]) : _vm._e()], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [(_vm.flag === 'br') ? _c('span', [_vm._v(_vm._s(_vm.$route.meta.namePtbr.toUpperCase()))]) : (_vm.flag === 'de') ? _c('span', [_vm._v(_vm._s(_vm.$route.meta.nameDe.toUpperCase()))]) : (_vm.flag === 'us') ? _c('span', [_vm._v(_vm._s(_vm.$route.meta.nameEn.toUpperCase()))]) : _c('span', [_vm._v(_vm._s(_vm.$route.meta.nameEs.toUpperCase()))]), _vm._v(" "), (_vm.flag === 'br') ? _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionPtbr))]) : (_vm.flag === 'de') ? _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionDe))]) : (_vm.flag === 'us') ? _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEn))]) : _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEs))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), (_vm.flag === 'br') ? _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.namePtbr.toUpperCase()))]) : (_vm.flag === 'de') ? _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.nameDe.toUpperCase()))]) : (_vm.flag === 'us') ? _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.nameEn.toUpperCase()))]) : _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.nameEs.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('dash-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Granmolino")])])
}]}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('languages-menu'), _vm._v(" "), _c('notifications-menu'), _vm._v(" "), _c('user-menu', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": "/static/img/bi-logo-archea-biogas2.svg",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pictureUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('div', [_c('p', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.displayName))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('form', {
    staticClass: "sidebar-form",
    attrs: {
      "id": "searchForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-success"
  }), _vm._v(" Online\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group",
    attrs: {
      "id": "searchContainer"
    }
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('input', {
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "data-toggle": "hideseek",
      "p": "",
      "laceholder": "Search Menus",
      "data-list": ".sidebar-menu"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.exibirGrafico) ? _c('div', {
    staticClass: "box-header"
  }, [_c('va-chart', {
    attrs: {
      "chart-config": _vm.producaoGrafico
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [(_vm.flag === 'br') ? _c('h3', [_vm._v("Requisitos de pesquisa")]) : (_vm.flag === 'de') ? _c('h3', [_vm._v("Suchanforderungen")]) : (_vm.flag === 'us') ? _c('h3', [_vm._v("Search Requirements")]) : _c('h3', [_vm._v("Requerimientos de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.flag === 'br') ? _c('h4', [_vm._v("Período")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Zeitraum")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Period")]) : _c('h4', [_vm._v("Periodo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [(_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Startdatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Initial date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Fecha de inicio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Startdatum auswählen",
      "id": "dataInicioBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select start date",
      "id": "dataInicioBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de inicio",
      "id": "dataInicioBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), (_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Enddatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Final date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Fecha final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Wählen Sie das Enddatum",
      "id": "dataFimBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select end date",
      "id": "dataFimBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de finalización",
      "id": "dataFimBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.flag === 'br') ? _c('h4', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Parameter")]) : _c('h4', [_vm._v("Parámetro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.flag === 'br') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o parâmetro")]) : (_vm.flag === 'de') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Parameter auswählen")]) : (_vm.flag === 'us') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Parameter")]) : _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_acumulador'), 'labelPtBr')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelPtBr, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelPtBr))])
  }) : (_vm.flag === 'de') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_acumulador'), 'labelDe')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelDe, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelDe))])
  }) : (_vm.flag === 'us') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_acumulador'), 'labelEn')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEn, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEn))])
  }) : _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_acumulador'), 'labelEs')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEs, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEs))])
  })], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.efetuarPesquisa(_vm.flag)
      }
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Efetuar Pesquisa")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Suche")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Search")]) : _c('span', [_vm._v("Buscar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flag === 'br') ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderBy(_vm.registros, 'labelPtBr')), function(registro) {
    return (registro.exibir) ? _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    }))), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n               " + _vm._s(registro.data_atualizacao) + "\n             ")])])])]) : _vm._e()
  })) : (_vm.flag === 'de') ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderBy(_vm.registros, 'labelDe')), function(registro) {
    return (registro.exibir) ? _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    }))), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n               " + _vm._s(registro.data_atualizacao) + "\n             ")])])])]) : _vm._e()
  })) : (_vm.flag === 'us') ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderBy(_vm.registros, 'labelEn')), function(registro) {
    return (registro.exibir) ? _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    }))), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n               " + _vm._s(registro.data_atualizacao) + "\n             ")])])])]) : _vm._e()
  })) : _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderBy(_vm.registros, 'labelEs')), function(registro) {
    return (registro.exibir) ? _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    }))), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n               " + _vm._s(registro.data_atualizacao) + "\n             ")])])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.producaoGraficoTitulo))])]), _vm._v(" "), (_vm.carregar) ? _c('va-chart', {
    attrs: {
      "chart-config": _vm.producaoGrafico
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('hr', {
    staticClass: "visible-xs-block"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
}]}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.message.title))]), _vm._v(" "), _c('small', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message.createdAt))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message.body))])])])
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.exibirGrafico) ? _c('div', {
    staticClass: "box-header"
  }, [_c('va-chart', {
    attrs: {
      "chart-config": _vm.producaoGrafico
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [(_vm.flag === 'br') ? _c('h3', [_vm._v("Requisitos de pesquisa")]) : (_vm.flag === 'de') ? _c('h3', [_vm._v("Suchanforderungen")]) : (_vm.flag === 'us') ? _c('h3', [_vm._v("Search Requirements")]) : _c('h3', [_vm._v("Requerimientos de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.flag === 'br') ? _c('h4', [_vm._v("Período")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Zeitraum")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Period")]) : _c('h4', [_vm._v("Periodo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [(_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Startdatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Initial date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Fecha de inicio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Startdatum auswählen",
      "id": "dataInicioBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select start date",
      "id": "dataInicioBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de inicio",
      "id": "dataInicioBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), (_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Enddatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Final date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Fecha final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Wählen Sie das Enddatum",
      "id": "dataFimBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select end date",
      "id": "dataFimBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de finalización",
      "id": "dataFimBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.flag === 'br') ? _c('h4', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Parameter")]) : _c('h4', [_vm._v("Parámetro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.flag === 'br') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o parâmetro")]) : (_vm.flag === 'de') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Parameter auswählen")]) : (_vm.flag === 'us') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Parameter")]) : _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'exibir'), true, 'is_qualidade'), 'labelPtBr')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelPtBr, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelPtBr))])
  }) : (_vm.flag === 'de') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'exibir'), true, 'is_qualidade'), 'labelDe')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelDe, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelDe))])
  }) : (_vm.flag === 'us') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'exibir'), true, 'is_qualidade'), 'labelEn')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEn, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEn))])
  }) : _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'exibir'), true, 'is_qualidade'), 'labelEs')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEs, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEs))])
  })], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.efetuarPesquisa(_vm.flag)
      }
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Efetuar Pesquisa")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Suche")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Search")]) : _c('span', [_vm._v("Buscar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("#")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('th', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('th', [_vm._v("Parameter")]) : _c('th', [_vm._v("Parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Valor")]) : (_vm.flag === 'de') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Wert")]) : (_vm.flag === 'us') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Value")]) : _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', [(_vm.flag === 'br') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelPtBr')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  }) : (_vm.flag === 'de') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelDe')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  }) : (_vm.flag === 'us') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEn')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  }) : _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEs')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("#")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('th', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('th', [_vm._v("Parameter")]) : _c('th', [_vm._v("Parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")]) : (_vm.flag === 'de') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Wert")]) : (_vm.flag === 'us') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Value")]) : _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Histórico")]) : (_vm.flag === 'de') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Geschichte")]) : (_vm.flag === 'us') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Historic")]) : _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Historia")])])]), _vm._v(" "), _c('tbody', [(_vm.flag === 'br') ? _vm._l((_vm.orderBy(_vm.registros, 'labelPtBr')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  }) : (_vm.flag === 'de') ? _vm._l((_vm.orderBy(_vm.registros, 'labelDe')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  }) : (_vm.flag === 'us') ? _vm._l((_vm.orderBy(_vm.registros, 'labelEn')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  }) : _vm._l((_vm.orderBy(_vm.registros, 'labelEs')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n    "), _c('a', {
    attrs: {
      "href": "https://www.solidtectecnologia.com.br"
    }
  }, [_vm._v("Solidtec Tecnologia")])]), _vm._v(" "), (_vm.flag === 'br') ? _c('span', [_vm._v(". Todos os direitos reservados.")]) : (_vm.flag === 'de') ? _c('span', [_vm._v(". Alle rechte vorbehalten.")]) : (_vm.flag === 'us') ? _c('span', [_vm._v(". All rights reserved.")]) : _c('span', [_vm._v(". Todos los derechos reservados.")])])
},staticRenderFns: []}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.exibirGrafico) ? _c('div', {
    staticClass: "box-header"
  }, [_c('va-chart', {
    attrs: {
      "chart-config": _vm.producaoGrafico
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [(_vm.flag === 'br') ? _c('h3', [_vm._v("Requisitos de pesquisa")]) : (_vm.flag === 'de') ? _c('h3', [_vm._v("Suchanforderungen")]) : (_vm.flag === 'us') ? _c('h3', [_vm._v("Search Requirements")]) : _c('h3', [_vm._v("Requerimientos de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.flag === 'br') ? _c('h4', [_vm._v("Período")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Zeitraum")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Period")]) : _c('h4', [_vm._v("Periodo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [(_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Startdatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Initial date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Fecha de inicio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Startdatum auswählen",
      "id": "dataInicioBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select start date",
      "id": "dataInicioBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de inicio",
      "id": "dataInicioBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), (_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Enddatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Final date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Fecha final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Wählen Sie das Enddatum",
      "id": "dataFimBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select end date",
      "id": "dataFimBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de finalización",
      "id": "dataFimBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.flag === 'br') ? _c('h4', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Parameter")]) : _c('h4', [_vm._v("Parámetro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.flag === 'br') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o parâmetro")]) : (_vm.flag === 'de') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Parameter auswählen")]) : (_vm.flag === 'us') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Parameter")]) : _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, false, 'is_acumulador'), true, 'registrado'), 'labelPtBr')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelPtBr, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelPtBr))])
  }) : (_vm.flag === 'de') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, false, 'is_acumulador'), true, 'registrado'), 'labelDe')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelDe, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelDe))])
  }) : (_vm.flag === 'us') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, false, 'is_acumulador'), true, 'registrado'), 'labelEn')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEn, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEn))])
  }) : _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, false, 'is_acumulador'), true, 'registrado'), 'labelEs')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEs, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEs))])
  })], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.efetuarPesquisa(_vm.flag)
      }
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Efetuar Pesquisa")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Suche")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Search")]) : _c('span', [_vm._v("Buscar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.messages)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.messages)) + " message(s)")]), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.userInfo.messages), function(message) {
    return _c('message-item', {
      key: message.id,
      attrs: {
        "message": message
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("See All Messages")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/system128.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signIn($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Digite seu email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Digite sua senha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar")])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', {
    staticClass: "vertical-5p lead"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [(_vm.flag === 'br') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Páginas")]) : (_vm.flag === 'de') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Seiten")]) : (_vm.flag === 'us') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Pages")]) : _c('li', {
    staticClass: "header"
  }, [_vm._v("Páginas")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), (_vm.flag === 'br') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Main")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Home")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/manutencao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa ion-android-settings"
  }), _vm._v(" "), (_vm.flag === 'br') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Manutenção")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Wartung")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Maintenance")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Mantenimiento")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa ion-stats-bars"
  }), _vm._v(" "), (_vm.flag === 'br') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Gráficos")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Diagramme")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Charts")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Gráficos")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos"
    }
  }, [_c('a', [(_vm.flag === 'br') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Gerais")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Allgemein")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("General")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("General")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-material"
    }
  }, [_c('a', [(_vm.flag === 'br') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Material")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Material")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Material")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Material")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-acumulados"
    }
  }, [_c('a', [(_vm.flag === 'br') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Acumulados por dia")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Pro Tag akkumuliert")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Accumulated per day")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Acumulado por día")])])])], 1)])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/usuario"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), (_vm.flag === 'br') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuário")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Benutzer")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("User")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuario")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/logout"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), (_vm.flag === 'br') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Sair")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Ausloggen")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Logout")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Cerrar Sesión")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])
}]}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/system128.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [(_vm.flag === 'br') ? _c('h1', [_vm._v("Você está perdido?")]) : (_vm.flag === 'de') ? _c('h1', [_vm._v("Bist du verloren?")]) : (_vm.flag === 'us') ? _c('h1', [_vm._v("You are lost?")]) : _c('h1', [_vm._v("¿Usted está perdido?")]), _vm._v(" "), (_vm.flag === 'br') ? _c('h4', [_vm._v("Essa página não existe!")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("This page does not exist!")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("You are lost?")]) : _c('h4', [_vm._v("¡Esta página no existe!")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Ir para a principal.")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Gehe zum Haupt.")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Ve a la principal.")]) : _c('span', [_vm._v("Ve a la principal.")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown tasks-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " task(s)")]), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all tasks")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h3', [_vm._v("\n              Design some buttons\n              "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])])])])])
}]}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "notification-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.notification.labelPtBr))]), _vm._v(" "), _c('small', {
    staticClass: "time pull-right"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notification.data_atualizacao))])])])])])
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.user.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header",
    staticStyle: {
      "height": "auto",
      "min-height": "85px",
      "padding-bottom": "15px"
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _vm._l((_vm.user.roles), function(role) {
    return _c('small', {
      key: role
    }, [_vm._v(_vm._s(role))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/logout"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat btn-block"
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Logout")])])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Relatorios.js": 276,
	"./Users.js": 277,
	"./index.js": 69
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 434;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[274]);


// WEBPACK FOOTER //
// static/js/app.3d0f7169608fe17ffb99.js